/**
 * formatMatchTelemetryStats — Post-game copy from matchTelemetry record (SPY-114).
 * Application: pure formatting, no DOM.
 */

/**
 * @param {{ matchLengthMs?: number, forfeit?: boolean, winTeam?: string|null }|null|undefined} record
 * @returns {{ matchLengthText: string, forfeitText: string, winTeamText: string }}
 */
export function formatMatchTelemetryStats(record) {
  const ms = Math.max(0, Number(record?.matchLengthMs) || 0);
  const totalSec = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  const matchLengthText = `${minutes}:${String(seconds).padStart(2, '0')}`;
  const forfeitText = record?.forfeit ? 'Rendición' : 'No';
  const winTeamText = record?.winTeam ? String(record.winTeam) : '—';
  return { matchLengthText, forfeitText, winTeamText };
}
